// const ManageHome = () => import('@/components/Manage/manage.bot.template.vue')
const TicketComponent = () => import('@/components/Support/components/ticket.component.vue')
const AnnoucementsComponent = () => import('@/components/Support/components/annoucements.component.vue')
const UserGuidComponent = () => import('@/components/Support/components/userGuid.component.vue')
const ContactComponent = () => import('@/components/Support/components/contact.component.vue')

const ifAuthenticated = (to, from, next) => {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token)
    next('/')
    return
  }
  next()
}

export default [
  {
    path: 'ticket',
    name: 'TicketComponent',
    meta:{
      title: 'support'
    },
    component: TicketComponent,
    beforeEnter: ifAuthenticated
  },{
    path: 'Annoucements',
    name: 'AnnoucementsComponent',
    meta:{
      title: 'support'
    },
    component: AnnoucementsComponent,
    beforeEnter: ifAuthenticated
  },{
    path: 'UserGuid',
    name: 'UserGuidComponent',
    meta:{
      title: 'support'
    },
    component: UserGuidComponent,
    beforeEnter: ifAuthenticated
  },{
    path: 'Contact',
    name: 'ContactComponent',
    meta:{
      title: 'support'
    },
    component: ContactComponent,
    beforeEnter: ifAuthenticated
  },
]


// WEBPACK FOOTER //
// ./src/router/support.router.js